export const PREPARING_CONTRACTS_STATUSES: string[] = [
  'CONTRACT_REQUESTED',
  'RECONTRACTING',
];
